var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: {
          loading: _vm.loading.general,
          color: _vm.$constants.LOADING_COLOR,
        },
      }),
      _vm._v(" "),
      !_vm.loading.general
        ? [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", [
                      _c("label", [_vm._v("Presets выбора стран")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c("multiselect", {
                            attrs: {
                              options: _vm.$AllCountries,
                              multiple: true,
                              label: "name",
                              "track-by": "name",
                              placeholder: "Выберите страну",
                              "select-label": "Выбрать",
                              "deselect-label": "Убрать страну",
                            },
                            model: {
                              value: _vm.selectedCountries,
                              callback: function ($$v) {
                                _vm.selectedCountries = $$v
                              },
                              expression: "selectedCountries",
                            },
                          }),
                          _vm._v(" "),
                          _c("LoadingButton", {
                            attrs: {
                              title:
                                _vm.selectedCountryGroup !== null
                                  ? "Сохранить"
                                  : "Добавить",
                              className: "btn btn-outline-success",
                              onClick: () => _vm.addRecord("countryGroups"),
                              loading: _vm.loading.btn.addNewCountryGroupRecord,
                              type: "button",
                              color: _vm.$constants.SUCCESS_COLOR,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-1" }, [
                      _c("table", { staticClass: "table mt-0 table-sm" }, [
                        _c(
                          "tbody",
                          _vm._l(_vm.countryGroups, function (r, i) {
                            return _c("tr", [
                              _c(
                                "td",
                                _vm._l(r, function (c) {
                                  return _c(
                                    "span",
                                    { staticClass: "badge badge-primary mr-1" },
                                    [_vm._v(_vm._s(c.name))]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("td", { attrs: { align: "right" } }, [
                                _c(
                                  "div",
                                  { staticClass: "flex flex_gap_10" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-outline-info",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectForEdit(
                                              "countryGroup",
                                              i
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-edit",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("LoadingButton", {
                                      attrs: {
                                        title:
                                          '<i class="icon-fa icon-fa-remove"/>',
                                        className: "btn btn-outline-warning",
                                        onClick: () =>
                                          _vm.removeRecord(
                                            "countryGroups",
                                            r,
                                            i
                                          ),
                                        loading:
                                          _vm.loading.btn.removeCountryGroup[i],
                                        type: "button",
                                        color: _vm.$constants.WARNING_COLOR,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("label", [_vm._v("Дивизионы с авиа доставкой")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.sortArray(
                              Object.values(_vm.$AllDivisions ?? {}),
                              "title"
                            ),
                            multiple: true,
                            label: "title",
                            "track-by": "title",
                            placeholder: "Выберите дивизион",
                            "select-label": "Выбрать",
                            "deselect-label": "Убрать дивизион",
                          },
                          model: {
                            value: _vm.selectedDivision,
                            callback: function ($$v) {
                              _vm.selectedDivision = $$v
                            },
                            expression: "selectedDivision",
                          },
                        }),
                        _vm._v(" "),
                        _c("LoadingButton", {
                          attrs: {
                            title: "Сохранить",
                            className: "btn btn-outline-success",
                            onClick: () =>
                              _vm.addRecord("airDeliveryDivisions"),
                            loading: _vm.loading.btn.updateAirDeliveryDivisions,
                            type: "button",
                            color: _vm.$constants.SUCCESS_COLOR,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }